import i18n from "@/config/i18n";
import { syncMachineTranslationOverlay } from "@/config/i18n/machine-translation-overlay";
import {
  isMachineTranslationPreviewEnvironmentAllowed,
  setMachineTranslationPreviewSessionEnabled,
} from "@/config/i18n/machine-translation-preview";
import { useFeatureFlags } from "@/context/FeatureFlags";
import { UiFeatureFlagNames } from "@/gql/graphql";
import { useEffect } from "react";

export function useMachineTranslationPreviewSync(): void {
  const { canUseFeatureFlag } = useFeatureFlags();
  const sessionFlagEnabled = canUseFeatureFlag(
    UiFeatureFlagNames.MachineTranslationPreview
  );

  useEffect(() => {
    if (!isMachineTranslationPreviewEnvironmentAllowed()) {
      setMachineTranslationPreviewSessionEnabled(false);
    } else {
      setMachineTranslationPreviewSessionEnabled(sessionFlagEnabled);
    }

    void syncMachineTranslationOverlay(i18n);

    return () => {
      setMachineTranslationPreviewSessionEnabled(false);
      void syncMachineTranslationOverlay(i18n);
    };
  }, [sessionFlagEnabled]);
}
